import { useEffect, useState } from "react";

export const PHONE_COUNTRIES = [
  ["+33", "🇫🇷 +33"], ["+32", "🇧🇪 +32"],
  ["+41", "🇨🇭 +41"], ["+352", "🇱🇺 +352"],
  ["+49", "🇩🇪 +49"], ["+34", "🇪🇸 +34"],
  ["+39", "🇮🇹 +39"], ["+44", "🇬🇧 +44"],
  ["+31", "🇳🇱 +31"], ["+351", "🇵🇹 +351"],
  ["+353", "🇮🇪 +353"], ["+43", "🇦🇹 +43"],
  ["+48", "🇵🇱 +48"], ["+40", "🇷🇴 +40"],
  ["+420", "🇨🇿 +420"], ["+421", "🇸🇰 +421"],
  ["+237", "🇨🇲 +237"], ["+225", "🇨🇮 +225"],
  ["+221", "🇸🇳 +221"], ["+212", "🇲🇦 +212"],
  ["+213", "🇩🇿 +213"], ["+216", "🇹🇳 +216"],
  ["+241", "🇬🇦 +241"], ["+242", "🇨🇬 +242"],
  ["+243", "🇨🇩 +243"], ["+223", "🇲🇱 +223"],
  ["+226", "🇧🇫 +226"], ["+229", "🇧🇯 +229"],
  ["+228", "🇹🇬 +228"], ["+233", "🇬🇭 +233"],
  ["+234", "🇳🇬 +234"], ["+1", "🇺🇸🇨🇦 +1"],
];

export function splitInternationalPhone(value, fallbackDial = "+33") {
  const raw = String(value || "").trim();
  let digits = raw.replace(/\D/g, "");
  const international = raw.startsWith("+") || raw.startsWith("00");
  if (raw.startsWith("00")) digits = digits.slice(2);
  let dial = fallbackDial;
  let local = digits;
  if (international && digits) {
    const match = [...PHONE_COUNTRIES]
      .sort((a, b) => b[0].length - a[0].length)
      .find(([d]) => digits.startsWith(d.replace(/\D/g, "")));
    if (match) {
      dial = match[0];
      local = digits.slice(match[0].replace(/\D/g, "").length);
    } else {
      local = raw.startsWith("+") ? raw : `+${digits}`;
      return { dial, local };
    }
  } else if (local.startsWith("0")) {
    local = local.replace(/^0+/, "");
  }
  return { dial, local };
}

export function normalizeInternationalPhone(value, fallbackDial = "+33") {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (raw.startsWith("+") || raw.startsWith("00")) {
    const digits = raw.replace(/\D/g, "").replace(/^00/, "");
    return digits ? `+${digits}` : "";
  }
  const dialDigits = String(fallbackDial || "+33").replace(/\D/g, "");
  let local = raw.replace(/\D/g, "").replace(/^0+/, "");
  if (!local) return "";
  if (local.startsWith(dialDigits) && local.length > dialDigits.length + 5) {
    local = local.slice(dialDigits.length);
  }
  return `+${dialDigits}${local}`;
}

export default function InternationalPhoneField({
  value,
  onChange,
  defaultDial = "+33",
  selectStyle = {},
  inputStyle = {},
  rowStyle = {},
  selectClassName = "",
  inputClassName = "",
  required = false,
  placeholder = "6 23 21 92 19",
}) {
  const initial = splitInternationalPhone(value, defaultDial);
  const [dial, setDial] = useState(initial.dial);
  const parts = splitInternationalPhone(value, dial);

  useEffect(() => {
    const raw = String(value || "").trim();
    if (!raw) return;
    const parsed = splitInternationalPhone(raw, dial);
    if (parsed.dial !== dial) setDial(parsed.dial);
  }, [value, dial]);

  const changeDial = (nextDial) => {
    setDial(nextDial);
    if (parts.local) onChange(normalizeInternationalPhone(parts.local, nextDial));
  };
  const changeLocal = (raw) => onChange(normalizeInternationalPhone(raw, dial));

  return (
    <div style={{ display: "grid", width: "100%", gridTemplateColumns: "88px minmax(0, 1fr)", gap: ".45rem", ...rowStyle }}>
      <select
        aria-label="Indicatif pays"
        value={parts.dial}
        onChange={(e) => changeDial(e.target.value)}
        className={selectClassName}
        style={{ minWidth: 0, ...selectStyle }}
      >
        {PHONE_COUNTRIES.map(([d, label]) => <option key={d} value={d}>{label}</option>)}
      </select>
      <input
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        aria-label="Numéro de téléphone"
        required={required}
        value={parts.local}
        onChange={(e) => changeLocal(e.target.value)}
        placeholder={placeholder}
        className={inputClassName}
        style={{ minWidth: 0, ...inputStyle }}
      />
    </div>
  );
}
